import { useTranslation } from 'react-i18next'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  TableHead,
} from '@mui/material'
import { colors } from '@/theme/index.theme'

import { PersonalizationEngineChartType } from '@/state/personalization-engine/models'
import { CurrencyCodeEnum } from '@/enums'
import { getFormatNumber } from '@/utils'

import { useStyles } from './style'

type Props = {
  chartData: PersonalizationEngineChartType[]
}

export const ChartTableComponent = ({ chartData }: Props) => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  const sxCell = {
    padding: '10px',
    backgroundColor: colors.paper2,
    border: 'none',
    '&:last-child': {
      borderRight: 'none',
    },
  }

  return (
    <Box borderRadius={7} p={1.5} mt={1}>
      <TableContainer>
        <Table>
          <TableHead
            sx={{
              borderBottom: `0px solid transparent`,

              '& th': {
                padding: '5px 15px',
                backgroundColor: 'transparent',
                border: 'none',
                textTransform: 'none' as 'none',
              },
            }}
          >
            <TableRow>
              <TableCell className={classes.leftCell}>
                {t('labels.name')}
              </TableCell>
              <TableCell>{t('personalizationEngine.perc')}</TableCell>
              <TableCell className={classes.rightCell}>
                {t('personalizationEngine.turnover')}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {chartData &&
              chartData.length > 0 &&
              chartData.map(
                (dat: PersonalizationEngineChartType, index: number) => (
                  <TableRow key={dat.name}>
                    <TableCell sx={{ ...sxCell }}>
                      <Box component="div" display="flex" alignItems="center">
                        <Box
                          component="div"
                          className={`${classes.point} dot-${index}`}
                        />
                        <Box>
                          <Typography textTransform="capitalize">
                            {dat.name}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ ...sxCell }}>
                      {Number(dat.percentage).toFixed(2)}%
                    </TableCell>
                    <TableCell sx={{ ...sxCell }}>
                      {getFormatNumber(
                        Number(dat.turnover.toFixed(2)),
                        CurrencyCodeEnum.USD,
                      )}
                    </TableCell>
                  </TableRow>
                ),
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
